import EpisodePart from './EpisodePart';

export default EpisodePart;
